import { Divider } from "antd";
import { ChipsSkeleton, DetailsCardSkeleton, RedeemBarSkeleton, SkeletonBlock } from "./GiftcardDetailsSkeleton.shared";

export default function GiftcardDetailsSkeletonWeb() {
  return (
    <div className="flex w-full gap-10">
      <div className="flex-5 flex flex-col gap-6">
        <div className="rounded-xs flex flex-col gap-6 p-6 shadow-sm">
          <div className="flex flex-col gap-4">
            <DetailsCardSkeleton />
            <ChipsSkeleton />
          </div>
          <Divider className="m-0!" />
          <RedeemBarSkeleton />
        </div>
      </div>
      <div className="flex-2 outline-border-subtle rounded-xs flex flex-col self-start outline">
        <div className="flex w-full gap-4 p-4">
          <SkeletonBlock className="h-10 flex-1" />
          <SkeletonBlock className="h-10 flex-1" />
        </div>
        <div className="flex flex-col gap-3 px-3 py-4">
          <SkeletonBlock className="h-3 w-full" />
          <SkeletonBlock className="h-3 w-full" />
          <SkeletonBlock className="h-3 w-4/5" />
          <SkeletonBlock className="h-3 w-full" />
          <SkeletonBlock className="h-3 w-2/3" />
        </div>
      </div>
    </div>
  );
}
